import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Waves, Sparkles, Sun } from "lucide-react";
import { useMedia, resolveUrl } from "../../context/MediaContext";
import { KineticText, Reveal } from "../../lib/motion";

export default function PoolMidday() {
  const { slots } = useMedia();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgScale = useTransform(scrollYProgress, [0, 0.5, 1], [1.15, 1, 1.1]);
  const parallax = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section ref={ref} className="relative min-h-[100svh] flex items-center py-24 px-6">
      <div className="max-w-[1300px] mx-auto w-full">
        <div className="text-center mb-12">
          <Reveal>
            <span className="font-body text-xs tracking-[0.35em] uppercase text-[#201A17]/60">Midday &middot; 1:30 PM</span>
          </Reveal>
          <h2 className="font-display font-extrabold text-[#201A17] leading-[0.9] text-6xl md:text-8xl mt-4">
            <KineticText text="Dive into" />
            <span className="font-serif-i italic font-normal gradient-text"> the day</span>
          </h2>
        </div>

        <motion.div style={{ scale: imgScale }} className="relative rounded-[36px] overflow-hidden h-[52vh] md:h-[68vh] shadow-2xl">
          <motion.div style={{ y: parallax }} className="absolute inset-0 scale-110">
            <img src={resolveUrl(slots.cardAccommodation)} alt="Private pool" className="w-full h-full object-cover" />
          </motion.div>
          <div className="absolute inset-0 bg-gradient-to-t from-[#04140E]/50 via-transparent to-transparent" />

          {/* floating info */}
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div className="max-w-md">
              <h3 className="font-display font-bold text-white text-3xl md:text-4xl">The Private Pool & Spa</h3>
              <p className="text-white/80 mt-2 font-light">Sparkling waters, a bubbling spa and a sun-soaked tanning ledge &mdash; your own resort, in total privacy.</p>
            </div>
            <div className="flex flex-wrap gap-3">
              {[{ i: Waves, t: "Pool & Spa" }, { i: Sun, t: "Tanning Ledge" }, { i: Sparkles, t: "2 Pergolas" }].map((c) => (
                <div key={c.t} className="flex items-center gap-2 rounded-full bg-white/15 backdrop-blur-md border border-white/25 px-4 py-2 text-white">
                  <c.i size={16} className="text-[var(--amber-light)]" />
                  <span className="text-sm font-medium">{c.t}</span>
                </div>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Escape within RGV note */}
        <Reveal delay={0.1}>
          <p className="text-center max-w-2xl mx-auto mt-10 text-[#201A17]/70 text-lg font-light">
            Beyond the water: <span className="font-serif-i italic text-terra">patio dining, a grill, even mini golf</span> &mdash; relax in style, comfort and privacy right in the heart of the RGV.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
